import * as ActionTypes from '../actions/actionTypes'

export default function reduce(state = {}, action) {
    let stateLocation, activeStateLocation, panesStateLocation;

    switch(action.type) {
        case ActionTypes.BEGIN_DISPLAY_FEEDBACK_OVERLAY:
            activeStateLocation = action.payload.activeStateLocation;
            panesStateLocation = action.payload.panesStateLocation;
            let feedbackPanes = action.payload.feedbackPanes;

            return Object.assign({}, state, {
                [panesStateLocation] : feedbackPanes,
                [activeStateLocation] : true
            });
        case ActionTypes.SET_ACTIVE_FEEDBACK_PANE:
            stateLocation = action.payload.stateLocation;
            let paneId = action.payload.paneId;
            
            let panes = state[stateLocation].slice();

            panes.forEach((item) => {
                item.active = item.paneId === paneId;
            });

            return Object.assign({}, state, {
                [stateLocation] : panes
            });
        case ActionTypes.END_DISPLAY_FEEDBACK_PANES:
            panesStateLocation = action.payload.panesStateLocation;
            activeStateLocation = action.payload.activeStateLocation;
            return Object.assign({}, state, {
                [activeStateLocation] : false,
                [panesStateLocation] : []
            });
        case ActionTypes.SET_CAPTURED_FEEDBACK:
            stateLocation = action.payload.stateLocation;
            let capturedInfo = action.payload.feedbackInfo;

            return Object.assign({}, state, {
                [stateLocation] : capturedInfo
            });
        case ActionTypes.SEND_CAPTURED_FEEDBACK:
            let stageLocation = action.payload.stageLocation;
            let capturedLocation = action.payload.capturedLocation;
            return Object.assign({}, state, {
                [stageLocation] : state[capturedLocation]
            });
        case ActionTypes.CLEAR_CAPTURED_FEEDBACK:
            stateLocation = action.payload.stateLocation;
            return Object.assign({}, state, {
                [stateLocation] : null
            });
            case ActionTypes.SET_ACTIVE_FEEDBACK_PANE_FOCUS:
            stateLocation = action.payload.stateLocation;
            return Object.assign({}, state, {
                [stateLocation]: action.payload.shouldFocus
            });
	default:
	    return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/reducers/index.js